module.exports = __webpack_public_path__ + "img/Opportunity Dashboard.9e0d7402.svg";